// config.js
export const BASE_URL = "https://app.mindraise.io:3443";
//export const BASE_URL = 'http://localhost:3000';
